module.exports = __webpack_public_path__ + "static/img/standard_model.2c70e6d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/standard_model.jpeg
// module id = 9DoN
// module chunks = 0